enum ModelContractSteps {
    CONTRACT_DATA_FORM = 1,
    SIGNERS_REGISTER
}

export default ModelContractSteps;